
function HRChartOnline() {
    /// <summary>
    /// This object provides client-side functions for the Chart.HighResolution.Online.vb <br/>
    /// It generates a simple empty chart and fills the series by a getData()-request. <br/>
    /// The series can get updated by an optional VCMQ-event as well.
    /// <br/>
    /// Author: ARF<br />
    /// Date: 22.11.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.11.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.onlineChart = null;
    this.chartSeries = [];
    this.seriesIndex = 0;
    this.minEdit = 0;
    this.maxEdit = 0;
    this.bLimitsDirty = false;
    this.bSetLimits = true;
    this.bInit = true;
    this.digits = 3;
    this.bRawChart = false;
    this.bEmpty = false;

}

HRChartOnline.prototype = new vcTemplate();

HRChartOnline.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        if (me.bSetLimits) {
            me.minEdit = me.min;
            me.maxEdit = me.max;
        
        }
        me.chartSeries = [];
    
      //  Highcharts.setOptions({lang: { resetZoom: "armin" } });

        me.showInfo("", "", false);
        var ro = new RampOptions();

        var chart = ro.getTheme();
       
        chart.title = { text: "" }
        chart.chart.boost = { useGPUTranslations: true }
        chart.chart.animation = false;
        chart.chart.defaultSeriesType = "spline";
        chart.chart.marginLeft = 100;
        Highcharts.setOptions({ global: {useUTC: false } });
        chart.xAxis.min = new Date($.datepicker.formatDate('yy/mm/dd',$.datepicker.parseDate('dd.mm.yy', me.parameter.StartDate))).getTime();
        chart.xAxis.max = new Date($.datepicker.formatDate('yy/mm/dd', $.datepicker.parseDate('dd.mm.yy', me.parameter.EndDate)));
        chart.xAxis.max = chart.xAxis.max.setDate(chart.xAxis.max.getDate() + 1);
        chart.xAxis.labels.rotation = -90; 
        chart.xAxis.type = 'datetime';
        chart.xAxis.tickPixelInterval = 50;
        chart.xAxis.dateTimeLabelFormats = { day: '%d.%m.'};

        if (me.bSetLimits) {
            //add some digits if we have really small values - maybe it helps
            if ((me.max - me.min) < 2) {
                me.digits = 3;
            }
          

            chart.xAxis.events= {
                afterSetExtremes: function() {
                    if (me.bInit === false) {
                        if (this.min <= this.dataMin && this.max >= this.dataMax) {
                          
                            me.onlineChart.yAxis[0].setExtremes(me.minEdit, me.maxEdit);
                        } 
                    }
                    me.bInit = false;

                }
                
            }
        }


        
    
        chart.yAxis.labels = {formatter: function() { return Highcharts.numberFormat(this.value, 2, ',', '.'); } }
        chart.yAxis.title = { text: "" }
        //chart.yAxis.min = this.min;
        //chart.yAxis.max = this.max;
      
        chart.tooltip.formatter = function () { return this.series.name.n + '<br/><u>' + moment(new Date(this.x)).format('DD.MM.YYYY HH:mm:ss') + '</u><br/><b>' + Highcharts.numberFormat(this.y, me.digits, ',', '.') + '</b> [' + this.series.name.u + ']' };
        chart.tooltip. positioner= function() {return {x:0,y:0};}
      
        if (me.signalParameter.Series.length > 1) {
            chart.legend = {
                squareSymbol: true,
                enabled: true,
                labelFormatter: function() { return this.name.n + ' [' + this.name.u + ']' }
            }
        } else {
            chart.legend.enabled = false;
        }
      


        chart.chart.zoomType = "xy";
        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.container.obj.height(me.height-5);
        me.visual.find("#div-chart").html(me.container.obj);


        me.onlineChart = Highcharts.chart("div-chart-" + me.container.random, chart);

        me.fetchFirst();

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


HRChartOnline.prototype.fetchFirst = function () {
    /// <summary>
    /// This function fetches all series for the first day of the selected time interval<br/>
    /// It validates it the series already exists - if not it adds a new series otherwise it only updates the missing values
    /// </summary>
    var me = this;
    var param;
    var signalParam = {Series:[]};
    try {
        if (me.error) {
            return false;
        }
        me.initialLoadingFinished = false;

        me.start = moment(me.parameter.StartDate, "DD.MM.YYYY");
        me.end = moment(me.parameter.EndDate, "DD.MM.YYYY");
       
        param = me.parameter;
        param.StartDate = moment(me.start).toDate().format("dd.MM.yyyy");
        param.EndDate = moment(me.start).toDate().format("dd.MM.yyyy");


        signalParam.Series.push(me.signalParameter.Series[me.seriesIndex]);

        me.fetchSingleDay(param, signalParam);

        return true;
    } catch (ex) { me.writeError('fetch', ex); return false; }
};


HRChartOnline.prototype.fetchNext = function () {
    /// <summary>
    /// This function fetches all signals for the next day unil the last day of the selected time interval.
    /// </summary>
    var me = this;
    var param;
    var signalParam = { Series: [] };
    try {
        if (me.error) {
            return false;
        }

        if (me.initialLoadingFinished) {return true;}

        if (me.start < me.end || (me.seriesIndex < me.signalParameter.Series.length)) {



            if (me.seriesIndex < (me.signalParameter.Series.length-1)) {
                me.seriesIndex++;
            } else {
                me.start = moment(me.start).add(1, 'days');
                me.seriesIndex = 0;
            }

            param = me.parameter;
            param.StartDate = moment(me.start).toDate().format("dd.MM.yyyy");
            param.EndDate = moment(me.start).toDate().format("dd.MM.yyyy");
            signalParam.Series.push(me.signalParameter.Series[me.seriesIndex]);


            me.fetchSingleDay(param, signalParam);

        } 

        return true;
    } catch (ex) { me.writeError('fetchNext', ex); return false; }
};

HRChartOnline.prototype.fetchSingleDay = function(param, signalParam) {
    /// <summary>
    /// This function fetches all series incl series data from the HighResolution engine.<br/>
    /// It validates it the series already exists - if not it adds a new series otherwise it only updates the missing values
    /// </summary>
    var me = this;
    var d = [];
    var currentDate = null;
    var index = -1;
    var name;
    var start;
    var end;
    var i;
  
    try {
        if (me.error) {return false; }

        me.bEmpty = true;
      
        //fetch all series
        window.VisualCoreService.getData(me.vcvid, me.vcgid,getCurrentTimestamp(),0, 0,JSON.stringify(param),JSON.stringify(signalParam),1, 2,"",
            function (result) {
                start =  moment();
                var j;
                var bAdded = false;
                if (result == null) {
                    me.showMessage(me.resources.noEntriesExist, false);
                    me.visual.find("#div-loading").hide();
                    _VCMQ.produce($(me.visual), me.vcgid, 'HRCHART_FINISHED_LOADING', "");
                    return false;
                }
                if (result === false) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                


                for ( i = 0; i <= result.Series.length - 1; i++) {
                   // currentDate = null;
                    if (result.Series[i].SeriesListSignals.length > 0) {
                        //get the index of the series
                        index = me.getSeriesIndex(result.Series[i].SeriesListSignals[0].Id);

                        if (index === -1) {
                            //if no series exists for that id/bsaid - let's add a new
                            d = [];
                            for (j = 0; j <= result.Series[i].SeriesListSignals[0].Points.length - 1; j++) {


                                currentDate = me.getTimeFromDate(result.Series[i].SeriesListSignals[0].Points[j].PointDate);

                                //round to 2 decimals -  division to get it back as a number -otherwise string
                                d.push([ currentDate,result.Series[i].SeriesListSignals[0].Points[j].Value.toFixed(me.digits)/1]);
                              
                                //set the new/edited min/max limits for the chart
                                if (me.bSetLimits) {
                                    me.setMinMaxLimits(result.Series[i].SeriesListSignals[0].Points[j].Value);
                                }
                            
                            }

                            if (d.length > 0) {
                                me.bEmpty = false;
                                name = {
                                    n: result.Series[i].CaptionName,
                                    u: result.Series[i].CaptionUnit,
                                    id: result.Series[i].SeriesListSignals[0].Id
                                }
                                bAdded = true;
                                name.lastDate =  me.getTimeFromDate(result.Series[i].SeriesListSignals[0].Points[result.Series[i].SeriesListSignals[0].Points.length -1].PointDate);

                            

                                me.chartSeries.push({ 'name': name, 'data': d, 'color':result.Series[i].SeriesListSignals[0].SignalColor});
                            }
                        } else {
                            //we only update an existing series starting with the last date
                            //    console.info("insert points: " + result.Series[i].SeriesListSignals[0].Points.length);
                            for (j = 0; j <= result.Series[i].SeriesListSignals[0].Points.length - 1; j++) {


                                currentDate = me.getTimeFromDate(result.Series[i].SeriesListSignals[0].Points[j].PointDate);
                                if (currentDate > me.chartSeries[index].name.lastDate) {
                                    //round to 2 decimals - division to get it back as a number -otherwise string
                                    me.chartSeries[index].data.push([currentDate, result.Series[i].SeriesListSignals[0].Points[j].Value.toFixed(me.digits) / 1]);
                                    if (me.bSetLimits) {
                                        me.setMinMaxLimits(result.Series[i].SeriesListSignals[0].Points[j].Value);
                                    }
                                }
                            }
                            if (result.Series[i].SeriesListSignals[0].Points.length > 0) {
                                me.chartSeries[index].name.lastDate = me.getTimeFromDate(result.Series[i].SeriesListSignals[0].Points[result.Series[i].SeriesListSignals[0].Points.length -1].PointDate);
                            }
                        }
                    }
                }
              

                if (((parseInt(me.start - me.end) >= 0) && me.seriesIndex>=(me.signalParameter.Series.length-1)) && me.initialLoadingFinished === false) {

                   
                    me.initialLoadingFinished = true;
                    var counter = 0;
                    var s = {}
                  
                    me.loadAdditionalSeries();

                    for (i = 0; i < me.chartSeries.length; i++) {

                        s = {
                            "name": me.chartSeries[i].name,
                            "data": me.chartSeries[i].data,
                            "color": me.chartSeries[i].color
                         
                        }
                        if (me.bRawChart) {
                            s.type = "area";
                        }

                        me.onlineChart.addSeries(s);
                        counter += me.chartSeries[i].data.length;
                    }


                    if (me.bSetLimits) {
                        if (me.bLimitsDirty) {
                            
                            me.setMinMaxPlotlines();
                            me.onlineChart.yAxis[0].setExtremes(me.minEdit, me.maxEdit);
                        } else {
                            me.onlineChart.yAxis[0].setExtremes(me.min, me.max);
                        }
                    }
                    me.onlineChart.redraw();
                    me.visual.find("#div-loading").hide();
                    _VCMQ.produce($(me.visual), me.vcgid, 'HRCHART_FINISHED_LOADING', "");
                }
               
                end = moment();

                me.sendSeriesInfos();
                return true;
            }, function () {
                me.visual.find("#div-loading").hide();

                me.openInfoDialog(me.resources.tooManyPoints, { at: 'center center-20%', of: window });
               
            });

        return true;
    } catch (ex) { me.writeError('fetchSingleDay', ex); return false; }
};


HRChartOnline.prototype.loadAdditionalSeries = function () {
};


HRChartOnline.prototype.setMinMaxLimits = function (val) {
    /// <summary>
    /// Sets new min/max limits used to redraw the chart and set min/max plotlines
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }
      
        if (me.minEdit > val) {
            me.minEdit = val;
            me.bLimitsDirty = true;
        }
        if (me.maxEdit < val) {
            me.maxEdit = val;
            me.bLimitsDirty = true;
        }

        return true;
    } catch (ex) { writeError('setMinMaxLimits', ex); return false }
};


HRChartOnline.prototype.setMinMaxPlotlines = function () {
    var me = this;
    var minPlot;
    var maxPlot;

    try {
        if (me.error) { return false; }
     
            //creates new plotlines with values rounded to integers
        minPlot = { value: me.min, color: '#a00', dashStyle: "LongDash", zIndex: 3, width: 2, label: { text: "min"} };
        maxPlot = { value: me.max, color: '#a00', dashStyle: "LongDash", zIndex: 3, width: 2, label: { text: "max" } };
            me.onlineChart.yAxis[0].update({ plotLines: [minPlot, maxPlot] });
        return true;
    } catch (ex) { writeError('setMinMaxPlotlines', ex); return false }
};

HRChartOnline.prototype.getTimeFromDate = function (sDate) {
    /// <summary>
    /// Returns a proper date in ms
    /// </summary>
    var me = this;
    var dateTime;
    var aDate;
    try {
        if (me.error) { return false; }
        aDate = sDate.split(" ");
        aDate[0] = $.datepicker.formatDate('dd/mm/yy', $.datepicker.parseDate('dd.mm.yy', sDate));
        dateTime = moment(aDate[0] + ' ' + aDate[1], 'DD/MM/YYYY HH:mm:ss');

        return new Date(dateTime).getTime();

    } catch (ex) { writeError('getTimeFromDate', ex); return ""; }
};


HRChartOnline.prototype.getSeriesIndex = function (id) {
    /// <summary>
    /// Returns the chart series index based on the given id (bsaid) or -1 if not found
    /// </summary>
    var me = this;
    var index = -1;
    try {
        if (me.error) { return false; }
        for (var i = 0; i < me.chartSeries.length; i++) {
            if (me.chartSeries[i].name.id === id) { index = i; }
        };
        return index;
    } catch (ex) { writeError('getSeriesIndex', ex); return -1; }
};

HRChartOnline.prototype.sendSeriesInfos = function () {
    /// <summary>
    /// Generates a list of bsaid/chart color pairs and sends it as MQ-event
    /// It is used to update the chart colors in an external signal list
    /// </summary>
    var me = this;
    var infos = [];
    try {

            if (me.error === false) {
                $.each(me.onlineChart.series,
                    function() {
                        if (typeof (this.data) !== "undefined") {
                            if (this.data.length > 0) {
                               
                                infos.push({
                                    bsaid: this.name.id,
                                    color: this.color,
                                    lastDate: this.name.lastDate,
                                    lastVal: this.data[this.data.length - 1].y,
                                    unit: this.name.u
                                });
                            }
                        }
                    });

               
                if (infos.length > 0) {
                    _VCMQ.produce($(me.visual), me.vcgid, 'HRCHART_SERIESINFO', infos);
                }

                _VCMQ.produce($(me.visual), me.vcgid, 'HRCHART_DAYFINISHED', "");
            }
    } catch (ex) { writeError('sendSeriesInfos', ex);  }
};

HRChartOnline.prototype.doEvent = function (event) {
    /// <summary>
    /// Is used to dynamically update the chart entries by an external widget
    /// </summary>
    var me = this;
    try {

        switch (event.msg) {
            case 'HRCHART_DAYFINISHED':
                me.fetchNext();
                break;

            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};


HRChartOnline.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-chart').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};



function HRChartAlarm() {
    /// <summary>
    /// This object provides client-side functions for the Chart.HighResolution.Alarm.vb <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 14.9.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 14.9.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bLimitsDirty = true;
    this.bInit = false;
    //this.initialLoadingFinished = false;

}

HRChartAlarm.prototype = new HRChartOnline();


HRChartAlarm.prototype.setMinMaxLimits = function (val) {
    /// <summary>
    /// Sets new min/max limits used to redraw the chart and set min/max plotlines
    /// </summary>
    var me = this;

    try {

        //console.info("got val: " + val);
        //console.info("got min: " + me.minEdit);
        //console.info("got max: " + me.maxEdit);


        if (me.minEdit > val) {
            me.minEdit = val;
        }
        if (me.maxEdit < val) {
            me.maxEdit = val;
        }

           //console.info("got new max: " + me.maxEdit);


        if (me.error) { return false; }
        me.bLimitsDirty = true;

        return true;
    } catch (ex) { me.writeError('setMinMaxLimits', ex); return false }
};

HRChartAlarm.prototype.loadAdditionalSeries = function () {
    /// <summary>
    /// Sets new min/max limits used to redraw the chart and set min/max plotlines
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }

       // console.info(me.bEmpty);
        if (me.bEmpty) {me.container.obj.html($("<div>").addClass("ui-corner-all ui-state-error").html(me.resources.noEntriesExist));}
        //console.info(me.chartSeries[0].data[0][0]);
        //me.onlineChart.addSeries({
        //        "type": "area",
        //        "name": 'test',
        //    "data": [[me.chartSeries[0].data[0][0], 100], [me.chartSeries[0].data[me.chartSeries[0].data.length-1][0], 300]],
        //        "color": 'red'
        //    },
        //    false);
        //return true;
    } catch (ex) { writeError('loadAdditionalSeries', ex); return false }
};